export const getFormattedDate = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = date.toLocaleString('es-ES', { month: 'short' });
  const day = date.getDate().toString().padStart(2, '0');
  return `${month} ${day} - ${year}`;
};
